import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-submitted-form-popup',
  imports: [TranslateModule],
  templateUrl: './submitted-form-popup.component.html',
  styleUrl: './submitted-form-popup.component.css',
})
export class SubmittedFormPopupComponent {
  @Output() close = new EventEmitter<void>();

  ngOnInit() {
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    document.body.style.overflow = '';
    this.close.emit();
  }
}
